// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

import { createClientLogger } from '@azure/logger';

/**
 * @private
 */
export const callingComponentLogger = createClientLogger('communication-react:calling-component');